
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { Patologia } from "./atlas-patologia.modelview";
import { AtlasPatologiaProvider } from "../../providers/atlas-patologia/atlas-patologia";
import { ListasProvider } from "../../providers/listas/listas";

@Injectable()
export class AtlasPatologiaPageProvider {

    constructor(private atlasPatologiaProvider: AtlasPatologiaProvider,
        private listasProvider: ListasProvider) {

    }

    getAtlasPatologia(): Observable<Array<Patologia>> {
        return Observable.create(subscriber => {
            this.atlasPatologiaProvider.solicitarAtlasPatologia().subscribe(data => {
                console.log("documentos", data)

                var estudos: Array<Patologia> = []
                data.forEach(element => {
                    var estudo: Patologia = new Patologia()

                    estudo.titulo = element.title.rendered
                    estudo.descricao = element.content.rendered
                    estudo.eNovo = true
                    estudo.link = element.link
                    estudo.images = []

                    if (element.acf != undefined && element.acf.fotos != undefined) {
                        element.acf.fotos.map(item => {
                            let link = item.url
                            estudo.images.push(link)
                        })
                    }

                    estudos.push(estudo)
                });


                subscriber.next(estudos)

            }, err => {

            })
        })
    }

    requestLists(): Observable<any> {
        return this.listasProvider.requestAllLists()
    }
}


// WEBPACK FOOTER //
// ./src/pages/atlas-patologia/atlas-patologia.provider.ts